import { defineComponent as z, computed as C, h, mergeProps as N, Fragment as R } from "vue";
import w from "./ghl-ui.es1090.js";
import H from "./ghl-ui.es854.js";
import b from "./ghl-ui.es855.js";
import { createKey as O } from "./ghl-ui.es384.js";
import { pxfy as g } from "./ghl-ui.es856.js";
import { repeat as _ } from "./ghl-ui.es939.js";
import { skeletonLight as j } from "./ghl-ui.es1091.js";
import { useHoudini as A } from "./ghl-ui.es1092.js";
const E = Object.assign(Object.assign({}, b.props), {
  text: Boolean,
  round: Boolean,
  circle: Boolean,
  height: [String, Number],
  width: [String, Number],
  size: String,
  repeat: {
    type: Number,
    default: 1
  },
  animated: {
    type: Boolean,
    default: !0
  },
  sharp: {
    type: Boolean,
    default: !0
  }
}), D = z({
  name: "Skeleton",
  inheritAttrs: !1,
  props: E,
  setup(t) {
    A();
    const {
      mergedClsPrefixRef: n
    } = H(t), i = b("Skeleton", "-skeleton", w, j, t, n);
    return {
      mergedClsPrefix: n,
      style: C(() => {
        var r, o;
        const s = i.value, {
          common: {
            cubicBezierEaseInOut: y
          }
        } = s, c = s.self, {
          color: k,
          colorEnd: v,
          borderRadius: x
        } = c;
        let l;
        const {
          circle: m,
          sharp: B,
          round: P,
          width: e,
          height: a,
          size: p,
          text: f,
          animated: S
        } = t;
        p !== void 0 && (l = c[O("height", p)]);
        const d = m ? (r = e ?? a) !== null && r !== void 0 ? r : l : e, u = (o = m ? e ?? a : a) !== null && o !== void 0 ? o : l;
        return {
          display: f ? "inline-block" : "",
          verticalAlign: f ? "-0.125em" : "",
          borderRadius: m ? "50%" : P ? "4096px" : B ? "" : x,
          width: typeof d == "number" ? g(d) : d,
          height: typeof u == "number" ? g(u) : u,
          animation: S ? "" : "none",
          "--n-bezier": y,
          "--n-color-start": k,
          "--n-color-end": v
        };
      })
    };
  },
  render() {
    const {
      repeat: t,
      style: n,
      mergedClsPrefix: i,
      $attrs: r
    } = this, o = h("div", N({
      class: `${i}-skeleton`,
      style: n
    }, r));
    return t > 1 ? h(R, null, _(t, null).map((s) => [o, `
`])) : o;
  }
});
export {
  D as default,
  E as skeletonProps
};
